export const formatCurrency = (amount, store) => {
  const currencyCode = store?.currencyCode || "USD";
  const currencyLocale = store?.currencyLocale || "en-US";

  const numericAmount = Number(amount);

  if (!Number.isFinite(numericAmount)) {
    return "";
  }

  try {
    let formatted = new Intl.NumberFormat(currencyLocale, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay:
        currencyCode === "MAD" ? "code" : "symbol",
    }).format(numericAmount);

    if (currencyCode === "MAD") {
      formatted = formatted.replace("MAD", "DH");
    }

    return formatted;
    
  } catch (error) {
    console.error("Currency formatting error:", error);
    return `${numericAmount.toFixed(2)} ${currencyCode}`;
  }
};